import React from 'react';
import { injectIntl } from 'react-intl';
import BusComponent from '../BusComponent';

class ConfirmationPopup extends BusComponent {
    onConfirmClicked = () => {
        this.props.onConfirm();
        this.emit('CLOSE_MODAL');
    };

    onCancelClicked = () => {
        this.emit('CLOSE_MODAL');
    };

    render() {
        const { intl, children, confirmLabel, info } = this.props;

        return (
            <div className="confirmation-popup">
                <div className="confirmation-popup__content">{children}</div>
                {info && (
                    <div className="confirmation-popup__info" data-testid="confirmation-popup-info">
                        <i className="material-icons-outlined">info</i>
                        <div>{info}</div>
                    </div>
                )}
                <div className="confirmation-popup__actions">
                    <button
                        className="confirmation-popup__button confirmation-popup__button--secondary"
                        onClick={this.onCancelClicked}
                        data-testid="confirmation-popup-cancel"
                    >
                        {intl.formatMessage({ id: 'cancel' })}
                    </button>
                    <button
                        className="confirmation-popup__button confirmation-popup__button--primary"
                        onClick={this.onConfirmClicked}
                        data-testid="confirmation-popup-confirm"
                    >
                        {confirmLabel}
                    </button>
                </div>
            </div>
        );
    }
}

export default injectIntl(ConfirmationPopup);
